// ─── Pricing Plans ───

export const mockPricingPlansList = {
  rescode: 1,
  message: "Pricing plans fetched successfully",
  data: [
    {
      id: 1,
      name: "Monthly Speech Therapy (Min 24)",
      service_id: 1,
      session_type_id: null,
      billing_model: "MONTHLY_WITH_MINIMUM",
      monthly_price: 15000,
      minimum_visits: 24,
      total_visits: null,
      validity_days: null,
      allow_deduction: 1,
      is_active: 1,
      clinic_id: 1,
      service: { id: 1, name: "Speech Therapy" },
      sessionType: null,
    },
    {
      id: 2,
      name: "Monthly OT (Attendance Based)",
      service_id: 2,
      session_type_id: null,
      billing_model: "MONTHLY_WITHOUT_MINIMUM",
      monthly_price: 12000,
      minimum_visits: null,
      total_visits: null,
      validity_days: null,
      allow_deduction: 1,
      is_active: 1,
      clinic_id: 1,
      service: { id: 2, name: "Occupational Therapy" },
      sessionType: null,
    },
    {
      id: 3,
      name: "15-Visit Package",
      service_id: 1,
      session_type_id: null,
      billing_model: "FIXED_VISIT_PACKAGE",
      monthly_price: 15000,
      minimum_visits: null,
      total_visits: 15,
      validity_days: 30,
      allow_deduction: 0,
      is_active: 1,
      clinic_id: 1,
      service: { id: 1, name: "Speech Therapy" },
      sessionType: null,
    },
  ],
};

export const mockPricingPlanCreate = {
  rescode: 1,
  message: "Pricing plan created successfully",
  data: { id: 4 },
};

export const mockPricingPlanToggle = {
  rescode: 1,
  message: "Plan status toggled",
  data: { is_active: 0 },
};

// ─── Patient Plans ───

export const mockPatientPlanGet = {
  rescode: 1,
  message: "Patient plan fetched",
  data: {
    id: 1,
    patient_id: 10,
    pricing_plan_id: 1,
    start_date: "2026-02-01",
    end_date: null,
    visits_used: 0,
    status: "ACTIVE",
    pricingPlan: {
      id: 1,
      name: "Monthly Speech Therapy (Min 24)",
      billing_model: "MONTHLY_WITH_MINIMUM",
      monthly_price: 15000,
      minimum_visits: 24,
    },
  },
};

export const mockPatientPlanList = {
  rescode: 1,
  message: "Patient plans fetched",
  data: [
    {
      id: 1,
      patient_id: 10,
      pricing_plan_id: 1,
      start_date: "2026-02-01",
      end_date: null,
      visits_used: 0,
      status: "ACTIVE",
      pricingPlan: {
        id: 1,
        name: "Monthly Speech Therapy (Min 24)",
        billing_model: "MONTHLY_WITH_MINIMUM",
        monthly_price: 15000,
        minimum_visits: 24,
      },
    },
  ],
};

export const mockPatientPlanAssign = {
  rescode: 1,
  message: "Plan assigned to patient successfully",
  data: { id: 2 },
};

export const mockPatientPlanClose = {
  rescode: 1,
  message: "Plan closed successfully",
  data: { message: "Plan closed successfully" },
};

// ─── Attendance ───

export const mockAttendanceList = {
  rescode: 1,
  message: "Attendance fetched successfully",
  data: [
    { id: 1, patient_id: 10, date: "2026-03-29", status: "PRESENT", patient: { UserId: 10, FirstName: "Arjun", LastName: "Sharma", Phone: "9876543210" } },
    { id: 2, patient_id: 11, date: "2026-03-29", status: "PATIENT_OFF", patient: { UserId: 11, FirstName: "Priya", LastName: "Patel", Phone: "9876543211" } },
    { id: 3, patient_id: 12, date: "2026-03-29", status: "PRESENT", patient: { UserId: 12, FirstName: "Rohan", LastName: "Gupta", Phone: "9876543212" } },
    { id: 4, patient_id: 13, date: "2026-03-29", status: "CENTRE_OFF", patient: { UserId: 13, FirstName: "Meera", LastName: "Singh", Phone: "9876543213" } },
    { id: 5, patient_id: 14, date: "2026-03-29", status: "PRESENT", patient: { UserId: 14, FirstName: "Kavya", LastName: "Joshi", Phone: "9876543214" } },
    { id: 6, patient_id: 15, date: "2026-03-29", status: "PATIENT_OFF", patient: { UserId: 15, FirstName: "Aditya", LastName: "Verma", Phone: "9876543215" } },
  ],
};

export const mockAttendanceMark = {
  rescode: 1,
  message: "Attendance marked successfully",
  data: { id: 7, patient_id: 10, date: "2026-03-04", status: "PRESENT" },
};

export const mockCentreOff = {
  rescode: 1,
  message: "Centre off marked for 5 patients",
  data: [
    { patient_id: 10, status: "CENTRE_OFF" },
    { patient_id: 11, status: "CENTRE_OFF" },
  ],
};

// ─── Wallet ───

export const mockWalletBalance = {
  rescode: 1,
  message: "Wallet balance fetched",
  data: { balance: 5000 },
};

export const mockWalletAddPayment = {
  rescode: 1,
  message: "Payment added to wallet",
  data: { balance: 20000, transaction: { id: 1, type: "CREDIT", amount: 15000, balance_after: 20000 } },
};

export const mockWalletRefund = {
  rescode: 1,
  message: "Refund processed",
  data: { balance: 3000, deducted: 2000, remaining: 0, transaction: { id: 2, type: "DEBIT", amount: 2000 } },
};

export const mockWalletTransactions = {
  rescode: 1,
  message: "Wallet transactions fetched",
  data: [
    { id: 1, patient_id: 10, type: "CREDIT", amount: 15000, balance_after: 15000, description: "Payment received", reference_type: "MANUAL", created_at: "2026-02-01T10:00:00.000Z" },
    { id: 2, patient_id: 10, type: "CREDIT", amount: 5000, balance_after: 20000, description: "Payment received", reference_type: "MANUAL", created_at: "2026-02-15T10:00:00.000Z" },
    { id: 3, patient_id: 10, type: "DEBIT", amount: 15000, balance_after: 5000, description: "Month-end settlement: BIL-202602-00001", reference_type: "BILLING_INVOICE", created_at: "2026-02-28T23:00:00.000Z" },
  ],
};

// ─── Settlement & Invoices ───

export const mockSettlementPreview = {
  rescode: 1,
  message: "Settlement preview generated",
  data: {
    periodStart: "2026-03-01",
    periodEnd: "2026-03-31",
    month: 3,
    year: 2026,
    previews: [
      {
        patientPlanId: 1,
        patientId: 10,
        patientName: "Arjun Sharma",
        patientPhone: "9876543210",
        planName: "Monthly Speech Therapy (Min 24)",
        billingModel: "MONTHLY_WITH_MINIMUM",
        presentDays: 20,
        patientOffDays: 3,
        centreOffDays: 4,
        workingDays: 27,
        totalAmount: 15000,
        walletBalance: 5000,
        walletDeduction: 5000,
        balanceAmount: 10000,
        breakdown: {
          formula: "Full monthly price (billable >= effective minimum)",
          monthly_price: 15000,
          minimum_visits: 24,
          effective_minimum: 24,
          billable_days: 23,
          result: 15000,
        },
      },
      {
        patientPlanId: 2,
        patientId: 11,
        patientName: "Priya Patel",
        patientPhone: "9876543211",
        planName: "Monthly OT (Attendance Based)",
        billingModel: "MONTHLY_WITHOUT_MINIMUM",
        presentDays: 18,
        patientOffDays: 5,
        centreOffDays: 4,
        workingDays: 27,
        totalAmount: 8000,
        walletBalance: 12000,
        walletDeduction: 8000,
        balanceAmount: 0,
        breakdown: {
          formula: "present_days x per_day_price",
          monthly_price: 12000,
          working_days: 27,
          per_day_price: 444.44,
          present_days: 18,
          result: 8000,
        },
      },
    ],
  },
};

export const mockSettlementGenerate = {
  rescode: 1,
  message: "2 invoices generated",
  data: {
    periodStart: "2026-03-01",
    periodEnd: "2026-03-31",
    invoicesGenerated: 2,
    invoices: [
      { id: 1, invoice_number: "BIL-202603-00001", patient_id: 10, total_amount: 15000, wallet_deducted: 5000, balance_amount: 10000, status: "PARTIAL" },
      { id: 2, invoice_number: "BIL-202603-00002", patient_id: 11, total_amount: 8000, wallet_deducted: 8000, balance_amount: 0, status: "PAID" },
    ],
  },
};

export const mockBillingInvoiceGet = {
  rescode: 1,
  message: "Billing invoice fetched",
  data: {
    id: 1,
    invoice_number: "BIL-202603-00001",
    patient_id: 10,
    patient_plan_id: 1,
    billing_period_start: "2026-03-01",
    billing_period_end: "2026-03-31",
    total_days: 31,
    working_days: 27,
    present_days: 20,
    patient_off_days: 3,
    centre_off_days: 4,
    billing_model: "MONTHLY_WITH_MINIMUM",
    calculation_breakdown: {
      formula: "Full monthly price (billable >= effective minimum)",
      monthly_price: 15000,
      minimum_visits: 24,
      effective_minimum: 24,
      billable_days: 23,
      result: 15000,
    },
    total_amount: 15000,
    wallet_deducted: 5000,
    paid_amount: 5000,
    balance_amount: 10000,
    status: "PARTIAL",
    patient: { UserId: 10, FirstName: "Arjun", LastName: "Sharma", Phone: "9876543210", Email: "arjun@test.com", wallet_balance: 0 },
    patientPlan: {
      id: 1,
      pricingPlan: { id: 1, name: "Monthly Speech Therapy (Min 24)", billing_model: "MONTHLY_WITH_MINIMUM", monthly_price: 15000 },
    },
  },
};

export const mockBillingInvoicesList = {
  rescode: 1,
  message: "Billing invoices fetched",
  data: {
    total: 2,
    invoices: [
      { id: 1, invoice_number: "BIL-202603-00001", patient_id: 10, total_amount: 15000, wallet_deducted: 5000, paid_amount: 5000, balance_amount: 10000, status: "PARTIAL", billing_period_start: "2026-03-01", billing_period_end: "2026-03-31", billing_model: "MONTHLY_WITH_MINIMUM", created_at: "2026-03-31T23:00:00.000Z", patient: { UserId: 10, FirstName: "Arjun", LastName: "Sharma", Phone: "9876543210" } },
      { id: 2, invoice_number: "BIL-202603-00002", patient_id: 11, total_amount: 8000, wallet_deducted: 8000, paid_amount: 8000, balance_amount: 0, status: "PAID", billing_period_start: "2026-03-01", billing_period_end: "2026-03-31", billing_model: "MONTHLY_WITHOUT_MINIMUM", created_at: "2026-03-31T23:00:00.000Z", patient: { UserId: 11, FirstName: "Priya", LastName: "Patel", Phone: "9876543211" } },
    ],
  },
};
